import { Injectable, Signal } from '@angular/core';
import { debitDayCatalog$$ } from '../lists/debit-day.catalog';
import { refusedCatalog$$ } from '../lists/refused.catalog';
import { TCatalogGraphicOption, TCatalogOption } from '../model';
import {
  beneficiaryYesNo$$,
  genderCatalog$$,
  leadStatusCatalog$$,
  locationCatalog$$,
  maritalStatusCatalog$$,
  onlineUseStatusCatalog$$,
  yesNoCatalog$$
} from './../lists';

@Injectable({
  providedIn: 'root'
})
export class LocalCatalog {
  static get maritalStatusList$$(): Signal<TCatalogOption[]> {
    return maritalStatusCatalog$$;
  }
  static get leadStatusList$$(): Signal<TCatalogOption[]> {
    return leadStatusCatalog$$;
  }
  static get onlineUseStatusList$$(): Signal<TCatalogOption[]> {
    return onlineUseStatusCatalog$$;
  }
  static get genderList$$(): Signal<TCatalogGraphicOption[]> {
    return genderCatalog$$;
  }
  static get refusedList$$(): Signal<TCatalogOption[]> {
    return refusedCatalog$$;
  }
  static get yesNoCatalog$$(): Signal<TCatalogOption[]> {
    return yesNoCatalog$$;
  }

  static get beneficiaryYesNo$$(): Signal<TCatalogOption[]> {
    return beneficiaryYesNo$$;
  }
  
  static get locationCatalog$$(): Signal<TCatalogOption[]> {
    return locationCatalog$$;
  }
  static get debitDayCatalog$$(): Signal<TCatalogOption[]> {
    return debitDayCatalog$$;
  }
  constructor() {}
}
